import {NgModule} from '@angular/core';
import {SyntoDocumentListModule as LibDocumentListModule} from 'synto-common/document-list-common';

@NgModule({
  imports: [LibDocumentListModule],
  exports: [LibDocumentListModule]
})
export class SyntoDocumentListModule {
}
